<template>
  <div
    class="tw-w-full tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-transition-colors"
    :class="[
      fillClass,
      paddingClass,
      { 'hover:tw-border-gray-400': hoverable || clickable },
      { 'tw-cursor-pointer': clickable },
    ]"
    :role="clickable ? 'button' : undefined"
    :tabindex="clickable ? 0 : undefined"
    @click="activate"
    @keydown.enter="activate"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    surface?: 'white' | 'grey'
    transparent?: boolean
    padding?: 'none' | 'sm' | 'md'
    clickable?: boolean
    hoverable?: boolean
  }>(),
  {
    surface: 'white',
    padding: 'md',
  },
)

const emit = defineEmits<{ click: [event: Event] }>()

const fillClass = computed(() => {
  if (props.transparent) {
    return 'tw-bg-transparent'
  }
  return props.surface === 'grey' ? 'tw-bg-white' : 'tw-bg-true-gray-50'
})

const paddingClass = computed(() => ({ none: '', sm: 'tw-p-3', md: 'tw-p-4' })[props.padding] ?? '')

const activate = (event: Event) => {
  if (props.clickable) {
    emit('click', event)
  }
}
</script>
